import React from 'react';
import { Navigate } from 'react-router-dom';
import { isPlatformSuperadmin, readStoredUser } from '@/auth/saasSession';

export default function PlatformAdminRoute({ children }) {
  return isPlatformSuperadmin(readStoredUser()) ? children : <Navigate to="/dashboard" replace />;
}
